import { render } from "./ModernClock.vue?vue&type=template&id=77aff2a4&scoped=true"
import script from "./ModernClock.vue?vue&type=script&lang=js"
export * from "./ModernClock.vue?vue&type=script&lang=js"

import "./ModernClock.vue?vue&type=style&index=0&id=77aff2a4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77aff2a4"]])

export default __exports__